import { PropsWithChildren, ReactNode } from "react";

type DataStateProps = {
  isLoading?: boolean;
  isEmpty?: boolean;
  skeleton?: ReactNode;
  emptyState?: ReactNode;
};

function DataState({
  isLoading,
  isEmpty,
  skeleton,
  emptyState,
  children,
}: PropsWithChildren<DataStateProps>) {
  if (isLoading) return <>{skeleton}</>;
  if (isEmpty) return <>{emptyState}</>;

  return <>{children}</>;
}

export default DataState;
